import Weight from 'types/model/weight';

export function weightToString(weight: Weight): string {
  return `${weight.value} ${weight.unit}`;
}
